module.exports = __webpack_public_path__ + "static/smokey-bones-9e18057e4a87d04dcec74549ac7b340c.svg";